import {
  DeductionApplicationType,
  MoneyInput,
  WeightInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadDeductionCreateAtom = createMutationAtomFactory(
  'trade.loadDeductionCreate',
  (params: {
    loadId: string;
    facilityId: string;
    deductionTypeId: string;
    applicationType: DeductionApplicationType;
    weightValue?: WeightInput | null;
    priceValue?: MoneyInput | null;
    percentage?: number | null;
    notes?: string | null;
  }) => ({
    tradeLoadDeductionCreate: {
      __args: {
        input: {
          loadId: params.loadId,
          facilityId: params.facilityId,
          deductionTypeId: params.deductionTypeId,
          applicationType: params.applicationType,
          weightValue: params.weightValue ?? null,
          priceValue: params.priceValue ?? null,
          percentage: params.percentage ?? null,
          notes: params.notes ?? null,
        },
      },
      id: true,
      loadId: true,
      deductionTypeId: true,
      applicationType: true,
      weightValue: {
        value: true,
        unit: true,
      },
      priceValue: {
        amount: true,
        currencyCode: true,
      },
      calculatedAmount: {
        amount: true,
        currencyCode: true,
      },
      notes: true,
    },
  }),
);
